import React from 'react';
import { Tooltip } from 'ui-toolkit';
import { ButtonTW } from 'tailwindComponents/buttonTW/ButtonTW';
import { VoidCheckButton } from '../Voiding/VoidCheckButton';
import { ICheckDisbursementFormData } from 'types/order/escrow/checks/ICheckDisbursementFormData';
import { Button } from '@zillow/constellation';
import { Show } from '../../../../../shared/Show';
import { useHasPermissions } from '../../../../../accessControl/hooks/useHasPermissions';
import { ePermissions } from '../../../../../../types/administration/userAdministration/ePermissions';

interface CheckActionsProps {
  isStaged: boolean;
  isReadOnly: boolean;
  hasDisbursePermissions: boolean;
  isDirty: boolean;
  data: ICheckDisbursementFormData;
  onPrintClick: () => void;
  onPrintAndSend: () => void;
}

export const CheckActions: React.FC<CheckActionsProps> = ({
  isStaged,
  isReadOnly,
  hasDisbursePermissions,
  isDirty,
  data,
  onPrintClick,
  onPrintAndSend,
}) => {
  const hasIssuanceDateEditPermissions = useHasPermissions([ePermissions.EscrowCheckIssuanceDateEdit]);

  return (
    <div className={'basis-full text-end'}>
      {isStaged && !isReadOnly && hasDisbursePermissions && (
        <Tooltip
          placement={'auto'}
          trigger={isDirty || data.holdback ? 'hover' : 'none'}
          tooltipContent={data.holdback ? 'Cannot send due to holdback' : 'Please save pending changes'}
        >
          <ButtonTW data-test-id={'print-check'} onClick={onPrintClick} disabled={data.holdback || isDirty}>
            Print Check
          </ButtonTW>
        </Tooltip>
      )}
      <Show when={isReadOnly && !data.voidedAt && data.sentAtDate == null && hasIssuanceDateEditPermissions}>
        <Button
          buttonType={'primary'}
          type="button"
          data-test-id={'confirm-send-check'}
          onClick={onPrintAndSend}
          disabled={data.holdback || isDirty}
          marginRight={'xs'}
        >
          Confirm Send
        </Button>
      </Show>
      <VoidCheckButton checkDisbursement={data} />
    </div>
  );
};
